<div class="header">
  <wm-common-text [data]="{ text: 'Help' }"></wm-common-text>
</div>

<div class="help-container">

  <div class="button-content">

    <div class="list-group-item">
      <a
        [href]="userGuideLink"
        target="_blank"
        rel="noopener"
        class="help-button-link"
      >
        User Guide
      </a>
    </div>

    <div class="list-group-item">
      <a
        [href]="trainingSiteLink"
        target="_blank"
        rel="noopener"
        class="help-button-link"
      >
        Training Site
      </a>
    </div>

    <div
      class="list-group-item"
      *ngIf="contactSupportLink"
    >
      <a
        [href]="contactSupportLink"
        target="_blank"
        rel="noopener"
        class="help-button-link"
      >
        Contact Support
      </a>
    </div>

  </div>

</div>